import { render, staticRenderFns } from "./ShiftBasedBarTrendWidget.vue?vue&type=template&id=850d3c58"
import script from "./ShiftBasedBarTrendWidget.vue?vue&type=script&lang=js"
export * from "./ShiftBasedBarTrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports